import env from '../data/env';

// eslint-disable-next-line no-console
const log = env.environment !== 'production' ? console.log : () => {};

export default log;